import { FormattedMessage } from 'react-intl'
import { Button, Text } from 'src/Components'

import styles from './AuthButtons.module.scss'

export const AuthButtons = ({ onClick }) => {
  return (
    <div className={styles.buttonGroup}>
      <div className={styles.buttonContainer}>
        <Button
          primary
          className={styles.signUpBtn}
          fullWidth
          onClick={onClick}
        >
          <Text element='span'>
            <FormattedMessage
              id='MobileHeader.signin.btn'
              defaultMessage='Sign up'
            />
          </Text>
        </Button>
      </div>
      <div className={styles.buttonContainer}>
        <Button fullWidth className={styles.logInBtn} onClick={onClick}>
          <Text element='span'>
            <FormattedMessage
              id='MobileHeader.login.btn'
              defaultMessage='Log in'
            />
          </Text>
        </Button>
      </div>
    </div>
  )
}
